var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup208(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 601,
    viewBox: "0 0 1440 601",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_309_418)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2422.51 300.931L-983.665 300.931",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2422.51 375.718L-983.665 375.717",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M121.824 376.089L30.4561 376.089",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2422.51 450.505L-983.665 450.504",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2422.51 525.282H-983.665",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2422.51 600.069H-983.665",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.1382 300V1122.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.19 300V1122.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M214.254 300L214.252 1122.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M306.312 300V1122.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M398.371 300V1122.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M490.423 300V1122.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M582.487 300V1122.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M674.546 300V1122.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M766.606 300V1122.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M858.666 300V1122.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M950.718 300V1122.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1042.78 300V1122.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1134.84 300V1122.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1226.9 300V1122.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1318.96 300V1122.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1411.02 300V1122.62",
    stroke: "#E4E2E2"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_309_418)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2422.51 0.930831L-983.665 0.930664",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2422.51 75.7175L-983.665 75.7173",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M121.824 76.0894L30.4561 76.0894",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2422.51 150.505L-983.665 150.504",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2422.51 225.282H-983.665",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2422.51 300.069H-983.665",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.1382 0V822.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.19 0V822.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M214.254 0L214.252 822.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M306.312 0V822.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M398.371 0V822.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M490.423 0V822.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M582.487 0V822.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M674.546 0V822.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M766.606 0V822.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M858.666 0V822.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M950.718 0V822.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1042.78 0V822.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1134.84 0V822.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1226.9 0V822.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1318.96 0V822.62",
    stroke: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1411.02 0V822.62",
    stroke: "#E4E2E2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_309_418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 301,
    fill: "white",
    transform: "translate(0 300)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_309_418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 301,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup208);
export default __webpack_public_path__ + "static/media/Group208.c9ef4cb8f135a2b20688cc4a601a6b27.svg";
export { ForwardRef as ReactComponent };